module.exports = __webpack_public_path__ + "img/zain-iraq.73c26a37.svg";